webpackJsonp([178043494660658],{

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CodeBlock = __webpack_require__(21);
	
	var _CodeBlock2 = _interopRequireDefault(_CodeBlock);
	
	var _Anchor = __webpack_require__(41);
	
	var _Anchor2 = _interopRequireDefault(_Anchor);
	
	var _DocPage = __webpack_require__(20);
	
	var _DocPage2 = _interopRequireDefault(_DocPage);
	
	var _ApiDocs = __webpack_require__(61);
	
	var _ApiDocs2 = _interopRequireDefault(_ApiDocs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _DocPage2.default,
	    { title: 'DateUtils API' },
	    _react2.default.createElement(
	      'p',
	      null,
	      'Set of functions useful to work with dates and modifiers.'
	    ),
	    _react2.default.createElement(
	      _CodeBlock2.default,
	      null,
	      'import { DateUtils } from "react-day-picker";'
	    ),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(
	      _ApiDocs2.default,
	      null,
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Functions'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_Anchor2.default, { id: 'addDayToRange' }),
	        'addDayToRange',
	        ' ',
	        _react2.default.createElement(
	          'code',
	          null,
	          '(day: Date, range: ?Object<from: ?Date, to: ?Date>) \u21D2 Object<from: ?Date, to: ?Date>'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Add ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'day'
	        ),
	        ' to a range of days, returning a new range including that day. A range is an object with ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'from'
	        ),
	        ' and',
	        ' ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'to'
	        ),
	        ' keys. See the range example for an example using this function.'
	      ),
	      _react2.default.createElement(
	        _CodeBlock2.default,
	        null,
	        'import { DateUtils } from "react-day-picker";\n\nconst range = {\n  from: new Date(2015, 5, 14),\n  to: new Date(2015, 5, 18)\n}\nconst newRange = DateUtils.addDayToRange(new Date(2015, 5, 24), range);\n\nconsole.log(newRange.to) // 2015-05-24'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_Anchor2.default, { id: 'addMonths' }),
	        'addMonths ',
	        _react2.default.createElement(
	          'code',
	          null,
	          '(date: Date, n: number) \u21D2 Date'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Return ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'date'
	        ),
	        ' as a new Date with ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'n'
	        ),
	        ' months added. Missing days will be added to the final date, e.g.',
	        ' ',
	        _react2.default.createElement(
	          'code',
	          null,
	          '2016-03-31 + 1 month = 2016-05-01'
	        ),
	        ' (since the 31th of April is missing).'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_Anchor2.default, { id: 'clone' }),
	        'clone ',
	        _react2.default.createElement(
	          'code',
	          null,
	          '(date: date) \u21D2 Date'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Clone ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'date'
	        ),
	        ' returning a new Date with the same time.'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_Anchor2.default, { id: 'isDate' }),
	        'isDate ',
	        _react2.default.createElement(
	          'code',
	          null,
	          '(value) \u21D2 Boolean'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Returns ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'true'
	        ),
	        ' if ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'value'
	        ),
	        ' is a valid Javascript Date.'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_Anchor2.default, { id: 'isDayAfter' }),
	        'isDayAfter ',
	        _react2.default.createElement(
	          'code',
	          null,
	          '(day1: Date, day2: Date) \u21D2 boolean'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Return ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'true'
	        ),
	        ' if ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'day1'
	        ),
	        ' is after ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'day2'
	        ),
	        '.'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_Anchor2.default, { id: 'isDayBefore' }),
	        'isDayBefore ',
	        _react2.default.createElement(
	          'code',
	          null,
	          '(day1: Date, day2: Date) \u21D2 boolean'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Return ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'true'
	        ),
	        ' if ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'day1'
	        ),
	        ' is before',
	        ' ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'day2'
	        ),
	        '.'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_Anchor2.default, { id: 'isDayBetween' }),
	        'isDayBetween ',
	        _react2.default.createElement(
	          'code',
	          null,
	          '(day: Date, day1: Date, day2: Date) \u21D2 boolean'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Returns ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'true'
	        ),
	        ' if ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'day'
	        ),
	        ' is between',
	        ' ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'day1'
	        ),
	        ' and ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'day2'
	        ),
	        ', without including those days.'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_Anchor2.default, { id: 'isDayInRange' }),
	        'isDayInRange',
	        ' ',
	        _react2.default.createElement(
	          'code',
	          null,
	          '(day: Date, range: Object<from: ?Date, to: ?Date>) \u21D2 boolean'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Returns ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'true'
	        ),
	        ' if ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'day'
	        ),
	        ' is included in the specified range of days.'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_Anchor2.default, { id: 'isFutureDay' }),
	        'isFutureDay ',
	        _react2.default.createElement(
	          'code',
	          null,
	          '(day: Date) \u21D2 boolean'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Return ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'true'
	        ),
	        ' if ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'day'
	        ),
	        ' is in the future, i.e. is tomorrow or any day after tomorrow.'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_Anchor2.default, { id: 'isPastDay' }),
	        'isPastDay ',
	        _react2.default.createElement(
	          'code',
	          null,
	          '(day: Date) \u21D2 boolean'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Return ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'true'
	        ),
	        ' if ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'day'
	        ),
	        ' is in the past, i.e. is yesterday or any day before yesterday.'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_Anchor2.default, { id: 'isSameDay' }),
	        'isSameDay ',
	        _react2.default.createElement(
	          'code',
	          null,
	          '(day1: ?Date, day2: ?Date) \u21D2 boolean'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Return ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'true'
	        ),
	        ' if ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'day1'
	        ),
	        ' and',
	        _react2.default.createElement(
	          'code',
	          null,
	          'day2'
	        ),
	        ' are the same day.'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(_Anchor2.default, { id: 'isSameMonth' }),
	        'isSameMonth ',
	        _react2.default.createElement(
	          'code',
	          null,
	          '(day1: ?Date, day2: ?Date) \u21D2 boolean'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Return ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'true'
	        ),
	        ' if ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'day1'
	        ),
	        ' and',
	        _react2.default.createElement(
	          'code',
	          null,
	          'day2'
	        ),
	        ' fall in the same month.'
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-api-date-utils-js-9fa6abecc9afa7f995fe.js